import { html } from "lit";
import { customElement, property } from "lit/decorators.js";

import { BaseElement } from "@/components";

@customElement("sb-subtitle")
export class SbSubtitle extends BaseElement {
  get _containerElement(): HTMLLIElement | null {
    return this.querySelector(
      `rtg-typography-p[part=${this.id ? this.id : "subtitle"}]`,
    );
  }
  @property({ type: String }) id!: string;
  @property({ type: String }) content!: string;

  protected createRenderRoot() {
    return this; // Render directly without Shadow DOM
  }

  render() {
    return html`
      <rtg-typography-p part=${this.id ? this.id : "subtitle"} id=${this.id}>
        ${this.content}
      </rtg-typography-p>
    `;
  }
}
